module.exports = __webpack_public_path__ + "media/fun/fun-2-dd31e7f5.jpg";